import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
// import '../../theme.css'
import './index.css'
import logo from '../../assets/images/logo.png'
import withRouter from '../common/customHooks/withRouter'

function LoginForm() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const navigate = useNavigate()

  const handleEmail = (e) => {
    setEmail(e.target.value)
  }

  const handlePassword = (e) => {
    setPassword(e.target.value)
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    if (email === 'customer@unravel.com' && password === '1234') {
      console.log('Welcome')
      navigate('recenttrip')
    } else {
      alert('Wrong Credentials')
    }

    console.log(email)
    console.log(password)
  }

  return (
    <div className="card-shadow">
      <div className="" style={{ margin: '20px', marginTop: '0px' }}>
        <form onSubmit={handleSubmit}>
          <img src={logo} className="logo" alt="unravel-logo" />
          <p className="sign-in ">Sign in</p>
          <div>
            <label className="label-email">Email ID</label>
            <input
              className="input-email"
              type="email"
              placeholder="Type Email ID"
              value={email}
              onChange={handleEmail}
              required
            ></input>
          </div>
          <div>
            <label className="label-password">Password</label>
            <input
              className="input-password"
              type="password"
              placeholder="Type Password"
              value={password}
              onChange={handlePassword}
              required
            ></input>
          </div>
          <div>
            <button
              type="submit"
              className="submit-button"
              style={
                email && password
                  ? { background: '#00857D', color: '#FFFFFF' }
                  : {}
              }
            >
              Sign in
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default withRouter(LoginForm)
